import './ClientRow.css';

function formatDate(dateString) {
  if (!dateString) return '—';
  return new Date(dateString).toLocaleDateString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric'
  });
}

export default function ClientRow({ client, isSelected, onClick, users }) {
  const { name, overallPercent, stageSummaries, rmUserId, onboardedAt, hasPendingReview } = client;

  const rmUser = users ? users.find(u => u._id === rmUserId) : null;
  const rmName = rmUser ? rmUser.name : '—';
  const percent = overallPercent || 0;

  function getActiveChips() {
    if (!stageSummaries) return [];
    const visible = [];
    for (let i = 0; i < stageSummaries.length; i++) {
      const s = stageSummaries[i];
      if (s.status === 'IN_PROGRESS' || s.status === 'PENDING_REVIEW') {
        visible.push(s);
      }
    }
    return visible.slice(0, 3);
  }

  function getChipClass(status) {
    if (status === 'IN_PROGRESS') return 'cj-row__chip cj-row__chip--progress';
    if (status === 'PENDING_REVIEW') return 'cj-row__chip cj-row__chip--review';
    return 'cj-row__chip';
  }

  const chips = getActiveChips();

  return (
    <button
      className={`cj-row ${isSelected ? 'cj-row--selected' : ''}`}
      onClick={onClick}
    >
      <div className="cj-row__top">
        <span className="cj-row__name">{name || '—'}</span>
        <div className="cj-row__top-right">
          <span className="cj-row__percent">{percent}%</span>
          {hasPendingReview && (
            <span className="cj-row__badge cj-row__badge--review">⏳</span>
          )}
        </div>
      </div>

      <div className="cj-row__sub">{rmName} · {formatDate(onboardedAt)}</div>

      <div className="cj-row__bar">
        <div className="cj-row__bar-fill" style={{ width: `${percent}%` }} />
      </div>

      {chips.length > 0 && (
        <div className="cj-row__chips">
          {chips.map(s => (
            <span key={s.stageUid} className={getChipClass(s.status)} title={s.stageName}>
              {s.stageName}
            </span>
          ))}
        </div>
      )}
    </button>
  );
}
